import api from './api.js'
import Ajax from './ajax.js'

//获取第三方服务机构分类列表
const getServiceTypeList=( params={})=>{
  return Ajax.get(api.getServiceTypeList  ,{params})
}

 
//获取最新资讯文字列表
const getInformationTextList=(params={})=>{
  return Ajax.post(api.getInformationTextList,params);
}

//获取政策解读列表
const getPolicyList=(params={})=>{
  return Ajax.post(api.getPolicyList,params);
}
 

//获取政策解读分类
const getPolicyTypeData=(params={})=>{
  return Ajax.post(api.getPolicyTypeData ,params)
}
 
//获取机构详情
const getInstitutionDetail = (suffix = '', params = {}) => {
  return Ajax.get(api.getInstitutionDetail + '/' + suffix, { params })
}

//获取服务产品列表
const getServiceProductList = (params = {}) => {
  return Ajax.get(api.getServiceProductList, params);
}

//获取服务资质-合作案例-团队介绍
const getServiceStrength = (params = {}) => {
  return Ajax.get(api.getServiceStrength , {params});
}
  
//获取详情
const getServiceInfoDetail = (suffix = '', params = {}) => {
  return Ajax.get(api.getServiceInfoDetail + '/' + suffix, params);
}
//获取第三方服务分类
const getServiceBuyType=( params={})=>{
  return Ajax.post(api.getServiceBuyType  ,params)
}
//获取第三方服务列表
const getServiceBuyList = (params = {}) => {
  return Ajax.post(api.getServiceBuyList, params);
}

//获取政策详情
const getPolicyDetailInfo = ( params = {}) => {
  return Ajax.get(api.getPolicyDetailInfo , {params});
}
//获取申报通知详情
const getReportDetailInfo = ( params = {}) => {
  return Ajax.post(api.getReportDetailInfo , params);
}
//获取资讯详情
const getNewsDetailInfo = (  params = {}) => {
  return Ajax.post(api.getNewsDetailInfo  , params);
}
//第三方服务
const getServiceDetail = (params = {}) => {
  return Ajax.post(api.getServiceDetail, params);
}
 
//获取企业基本信息
const getCompanyDetail = (suffix = '', params = {}) => {
  return Ajax.get(api.getCompanyDetail + '/' + suffix, params);
}
//获取政策匹配表单
const getSearchForm = (params = {}) => {
  return Ajax.get(api.getSearchForm, {params});
}
//搜索匹配政策
const searchPolicy = (params = {}) => {
  return Ajax.post(api.searchPolicy, params);
}
//购买服务
const bugSevice = (params = {}) => {
  return Ajax.post(api.bugSevice, params);
}
//获取政策申请-第三方服务机构列表
const getPolicySeviceList = (suffix = '', params = {}) => {
  return Ajax.get(api.getPolicySeviceList + '/' + suffix, params);
}
//政策申请接口
const getPolicyApplyList = (params = {}) => {
  return Ajax.post(api.getPolicyApplyList, params);
}
//政策预审核接口
const getPolicyPreApplyList = (params = {}) => {
  return Ajax.post(api.getPolicyPreApplyList, params);
}
//政策申请接口
const getServiceApplyList = (params = {}) => {
  return Ajax.post(api.getServiceApplyList, params);
}
//政策或服务咨询
const getPolicyTermsList = (params = {}) => {
  return Ajax.post(api.getPolicyTermsList, params);
}
//获取用户信息getUserInfo
const getUserInfo = (suffix = '', params = {}) => {
  return Ajax.post(api.getUserInfo + '/' + suffix, params);
}
// 登录
const login = ( params = {}) => {
  return Ajax.post(api.login , params);
}
 // 企业/机构注册
const regist = (  params = {}) => {
  return Ajax.post(api.regist  , params);
}
// 忘记密码-修改密码
const setPwd = (  params = {}) => {
  return Ajax.post(api.setPwd  , params);
}
// 修改密码
const resetPwd = (  params = {}) => {
  return Ajax.post(api.resetPwd  , params);
}
 // 修改账号
const resetAccount = ( params = {}) => {
  return Ajax.post(api.resetAccount  , params);
}
 // 注册获取校验码
const getVerifyCode = (  params = {}) => {
  return Ajax.post(api.getVerifyCode   , params);
}
// 检查校验码
const checkVerifyCode = ( params = {}) => {
  return Ajax.post(api.checkVerifyCode  , params);
} 
// 获取首页banner
const getBannerList= ( params = {}) => {
  return Ajax.post(api.getBannerList, params);
} 
//获取机构列表
const getInstitutionsList = (  params = {}) => {
  return Ajax.get(api.getInstitutionsList  , {params});
}  
//详情-申请时-获取机构列表
const getPolicyInstitutionsList = (  params = {}) => {
  return Ajax.get(api.getPolicyInstitutionsList, {params});
} 
//获取风采列表
const getNewTownStyleList = (  params = {}) => {
  return Ajax.post(api.getNewTownStyleList  , params);
}  
//获取风采分类列表
const getNewTownStyleType = (  params = {}) => {
  return Ajax.post(api.getNewTownStyleType  , params);
}  

//获取风采分类详情
const getNewStyleDetail = (  params = {}) => {
  return Ajax.get(api.getNewStyleDetail  , {params});
} 

//获取风采分类详情
const getHyqElasticSearchList = (  params = {}) => {
  return Ajax.post(api.getHyqElasticSearchList  , params);
} 

//所属行业
const getChildrenList = (  params = {}) => {
  return Ajax.get(api.getChildrenList  , { params });
}  

//企业属性
const companyTypeListPark = (  params = {}) => {
  return Ajax.get(api.companyTypeListPark  , { params });
} 
//所属行业
const getCompanyInfo = (  params = {}) => {
  return Ajax.get(api.getCompanyInfo  , { params });
}  
//增加阅读量
const incrPolicyCount = (  params = {}) => {
  return Ajax.post(`${api.incrPolicyCount}?policyId=${params.policyId}`, params);
}  
const incrInformCount = (  params = {}) => {
  return Ajax.post(`${api.incrInformCount}?informId=${params.informId}`, params);
}
const incrServerCount = (  params = {}) => {
  return Ajax.post(`${api.incrServerCount}?thirdServiceId=${params.thirdServiceId}`, params);
}  

//获取验证码
const getImageCode = (  params = {}) => {
  return Ajax.get(api.getImageCode  , { params });
}  
//获取园区
const getParkByPhone = (  params = {}) => {
  return Ajax.post(api.getParkByPhone, params);
}  
//获取风采列表
const getWebLogos = (  params = {}) => {
  return Ajax.get(api.getWebLogos  , {params});
}  
//获取科技型企业类型
const getTechMicroCompanyList = (  params = {}) => {
  return Ajax.get(api.getTechMicroCompanyList  , {params});
}  
//新增企业订单
const createBankOrder = (  params = {}) => {
  return Ajax.post(api.createBankOrder  , params);
}  
export default {
  getImageCode,
  createBankOrder,
  getTechMicroCompanyList,
  getParkByPhone,
  companyTypeListPark,
  incrServerCount,
  incrInformCount,
  incrPolicyCount,
  getCompanyInfo,
  getChildrenList,
  getInstitutionsList,
  getServiceTypeList,
  getInformationTextList,
  getPolicyList,
  getPolicyTypeData,
  getInstitutionDetail,
  getServiceProductList,
  getServiceStrength,
  getServiceInfoDetail,
  getServiceBuyType,
  getServiceBuyList,
  getPolicyDetailInfo,
  getReportDetailInfo,
  getNewsDetailInfo,
  getServiceDetail,
  getCompanyDetail,
  getSearchForm,
  searchPolicy,
  bugSevice,
  getPolicySeviceList,
  getPolicyApplyList,
  getPolicyPreApplyList,
  getServiceApplyList,
  getPolicyTermsList,
  getUserInfo,
  login,
  regist,
  setPwd,
  resetPwd,
  resetAccount,
  getVerifyCode,
  checkVerifyCode,
  getBannerList,
  getNewTownStyleList,
  getNewTownStyleType,
  getNewStyleDetail,
  getHyqElasticSearchList,
  getPolicyInstitutionsList,
  getWebLogos
}



// WEBPACK FOOTER //
// ./src/apis/control.js